import { createAnimation } from '@ionic/react';

export const NoAnimationBuilder = (baseEl: any, opts: any) => {
    const noAnimation = createAnimation()
        .addElement(opts.enteringEl)
        .duration(0);

    return noAnimation;
};
